import React, { createContext, useContext, useRef, useState } from 'react';
import { useOnClickOutside } from '@monofront/business/hooks';
import { Trigger } from './components/Trigger';

interface IDropdownItem {
  id: string;
  defaultChecked?: boolean;
  onItemClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
}

export interface IDropdownProps {
  label: string;
  dropdownItems: IDropdownItem[];
  selectedItemsCount?: number;
  onReset: () => void;
}

interface IDropdownContextProps extends IDropdownProps {
  isExpended: boolean;
  setIsExpended: React.Dispatch<React.SetStateAction<boolean>>;
}

const DropdownContext = createContext<IDropdownContextProps>({
  label: '',
  dropdownItems: [],
  selectedItemsCount: 0,
  isExpended: false,
  setIsExpended: () => ({}),
  onReset: () => ({}),
});

export const useDropdown = () =>
  useContext<IDropdownContextProps>(DropdownContext);

export const Dropdown: React.FC<
  IDropdownProps & { children: React.ReactNode }
> = ({ children, ...props }) => {
  const refContainer = useRef<HTMLDivElement>(null);
  const [isExpended, setIsExpended] = useState(false);

  useOnClickOutside(refContainer, () => setIsExpended(false));

  return (
    <DropdownContext.Provider value={{ ...props, isExpended, setIsExpended }}>
      <div className="tw-relative" ref={refContainer}>
        <Trigger />
        {isExpended ? (
          <div
            className={`
            tw-block
            tw-absolute
            tw-bg-white
            tw-mt-4
            tw-w-[300px]
            tw-shadow-dropdown
            tw-rounded-2xl
            tw-overflow-hidden
            tw-z-dropdown
          `}
          >
            {children}
          </div>
        ) : null}
      </div>
    </DropdownContext.Provider>
  );
};
